module.exports = __webpack_public_path__ + "img/my_page.77b4e741.svg";